import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableTransactionsByPlayerReports from 'views/regulations/transactionsByPlayer/tableTransactionsByPlayerReports'; // Importing table component for transactions
import FilterTransactionsByPlayerReports from 'views/regulations/transactionsByPlayer/filterTransactionsByPlayerReports'; // Importing filter component for transactions

/**
 * Class representing the view for transactions by player.
 * @extends JetView
 */
export default class TransactionsByPlayerView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        let vthis = this; // Reference to the current instance
        const toolbar = {
            id: 'toolbar', // Identifier for the toolbar
            view: 'toolbar', // Toolbar view
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns in the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change in selection
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                            vthis.app.callEvent('changeSize', [{}]); // Trigger change size event
                        },
                    },
                },
                {
                    id: 'pagerA', // Identifier for the pager
                    view: 'pager', // Pager view
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                },
                {
                    id: 'Export', // Identifier for the export dropdown
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select
                    width: 120, // Width of the select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection change
                            if (value === 1) {
                                // If Excel is selected
                                let table = $$('datatable'); // Reference to the datatable
                                for (let j = 0; j < table.config.columns.length; j++) {
                                    // Iterate through columns
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export data event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de las transacciones realizadas por cada jugador (Retiros)'),
                                        TypeReport: 'Excel', // Set report type to Excel
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de las transacciones realizadas por cada jugador (Retiros)'),
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export data event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Reporte de las transacciones realizadas por cada jugador (Retiros)'),
                                            TypeReport: 'PDF', // Set report type to PDF
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de las transacciones realizadas por cada jugador (Retiros)'),
                                        autowidth: true, // Enable auto width for PDF
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind the context
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            // Return the main configuration object
            id: 'a5', // Identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive configuration
                    type: 'wide', // Wide type for the row
                    cols: [
                        // Columns in the row
                        {
                            css: 'int-left', // CSS class for styling
                            rows: [
                                // Rows in the column
                                {
                                    view: 'toolbar', // Toolbar view
                                    css: theme, // Apply theme
                                    elements: [
                                        // Elements in the toolbar
                                        {
                                            view: 'label', // Label for the report title
                                            label: _(
                                                'Reporte de las transacciones realizadas por cada jugador (Retiros)',
                                            ),
                                        },
                                        {
                                            id: 'button-search', // Identifier for the search button
                                            type: 'wide', // Wide type for the button
                                            css: 'close-bottom', // CSS class for styling
                                            cols: [
                                                // Columns in the button
                                                {
                                                    view: 'icon', // Icon for the search button
                                                    icon: 'wxi-search', // Search icon
                                                    bottom: 20, // Bottom margin
                                                    right: 35, // Right margin
                                                    width: 30, // Width of the icon
                                                    height: 30, // Height of the icon
                                                    click: () => {
                                                        // Click event for the search button
                                                        $$('filterPopup').show(); // Show filter popup
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            type: 'wide', // Wide type for the close button
                                            css: 'close-bottom', // CSS class for styling
                                            cols: [
                                                // Columns in the button
                                                {
                                                    view: 'icon', // Icon for the close button
                                                    icon: 'wxi-close', // Close icon
                                                    bottom: 20, // Bottom margin
                                                    right: 35, // Right margin
                                                    width: 30, // Width of the icon
                                                    height: 30, // Height of the icon
                                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                                },
                                            ],
                                        },
                                    ],
                                },
                                FilterTransactionsByPlayerReports, // Filter component
                                TableTransactionsByPlayerReports, // Table component
                                toolbar, // Toolbar component
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Check screen size
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check screen size
                $$('button-search').hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
